import htmx from 'htmx.org';
//import 'htmx-ext-response-targets'; // Handles non-200 HTTP status codes
import 'htmx-ext-loading-states';   // Provides data-loading attributes for UX
//import 'htmx-ext-method-override';  // Allows PUT/DELETE via POST tunneling
//import 'htmx-ext-json-enc';			// Encodes form data as JSON strings
//import 'htmx-ext-sse';				// Server-Sent Events for real-time updates
//import 'htmx-ext-path-deps';		// Updates elements based on URL dependencies

export const initHTMX = (callback) => {

	// Global HTMX
	window.htmx = htmx;

	// Cache 
	var $body = $('body');

	// Since HTML non-GET request would require CSRF headers for security
	// limit all requests to GET
	// Anything that can change the state of the system (POST) should be done
	// via the form builder for CSRF protection
	$body.on('htmx:beforeRequest', (evt) => {

		const requestConfig = evt.detail.requestConfig;

		if (requestConfig && requestConfig.method) {

			const method = requestConfig.method.toUpperCase();

			if (method !== 'GET') {

				evt.preventDefault();
				
				console.error(`Security Policy: HTMX ${method} requests are prohibited`);

			}

		}

	});


	// Run modular code on new content
	$body.on('htmx:afterSwap', (e) => {
		
		// htmx puts the swapped element in the detail object
		const target = e.detail.target;

		if (typeof callback === 'function') {

			callback(target);

		}

	});

};